import { put, takeLatest } from "redux-saga/effects";
import { getCRMInfoApi } from "store/api/HomeApi";
import { GET_CRM_SHOP_INFO_ACTION } from "../../actions/HomePageAction/actionTypes";

import * as homePageAction from "../../actions/HomePageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getCRMInfo() {
	const res = yield getCRMInfoApi();
	try {
		if (res?.code === 0) {
			const dataShop = res?.data?.shop;
			yield put(homePageAction.setCRMShopInfoDetail(dataShop));
		} else {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	}
}

function* getCRMInfoSaga() {
	yield takeLatest(GET_CRM_SHOP_INFO_ACTION, getCRMInfo);
}

export default getCRMInfoSaga;
